import React from 'react';
import { Ssvg } from '../../../Components/react/Ssvg';
import { ppData } from '../configs/ppData.config';
const Separator = () => (React.createElement("li", { "aria-hidden": "true", className: "d:flex ai:center mx:6" },
    React.createElement(Ssvg, { icon: "#icon--arrow-breadcrumb", className: "h:6" })));
const Item = ({ href, children }) => (React.createElement("li", null,
    React.createElement("a", { href: href, className: "color:text hover:color:text-hover" }, children)));
const CustomPath = () => (React.createElement(Item, { href: "/collections/photo-prints" }, "Photo Prints"));
const ClassicPath = () => React.createElement(React.Fragment, null,
    React.createElement(Item, { href: "/collections" }, "Subjects"),
    ppData.hierarchyPath !== undefined
        ? ppData.hierarchyPath.map(({ name, handle }) => (React.createElement(React.Fragment, { key: handle },
            React.createElement(Separator, null),
            React.createElement(Item, { href: `/collections/${handle}` }, name))))
        : React.createElement(React.Fragment, null,
            React.createElement(Separator, null),
            React.createElement(Item, { href: "/collections" }, "Subjects")));
export const Breadcrumbs = () => (React.createElement("nav", { className: "fz:10 fz:12:md-up mb:16 mb:20:md-up", "aria-label": "breadcrumb" },
    React.createElement("ol", { className: "list:none text:uppercase d:flex fxw:wrap ai:center" },
        React.createElement(Item, { href: "/" }, "Home"),
        React.createElement(Separator, null),
        ppData.isOldCustom
            ? React.createElement(CustomPath, null)
            : React.createElement(ClassicPath, null))));
